import type { RouteRecordRaw } from "vue-router";

export const PriceCalculatorRoutes: RouteRecordRaw[] = [
  {
    path: "/price-calculator",
    redirect: { name: "quotes" },
  },
  {
    path: "/price-calculator/quotes/:id",
    redirect: to => ({ name: "quote", params: { id: to.params.id } }),
  },
  {
    path: "/quotes",
    name: "quotes",
    component: () => import("@cms/features/PriceCalculator/PriceCalculatorContainer.vue"),
    redirect: { name: "quotes-list" },
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "quotes-list",
        component: () => import("@cms/features/PriceCalculator/QuoteLibraryList.vue"),
      },
      {
        path: ":id",
        name: "quote",
        component: () => import("@cms/features/PriceCalculator/QuoteLibraryDetail.vue"),
      },
    ],
  },
];
